import { Link } from 'react-router-dom'
import { PowerOff } from 'lucide-react'

import { useAuth } from '@/auth/AuthContext'
import { Card } from '@/components/ui/Card'

/**
 * Ekran w miejsce sekcji, której szkoła nie używa.
 *
 * Świadomie nie jest to „brak dostępu”: rola użytkownika jest w porządku,
 * wyłączona jest cała funkcja. Konto serwisowe dostaje odnośnik do miejsca,
 * w którym moduł się włącza — reszta wskazówkę, którędy o to poprosić.
 */
export function ModuleDisabledNotice({ name }: { name: string }) {
  const { user } = useAuth()
  const serwis = user?.is_service === true

  return (
    <Card className="mx-auto max-w-xl">
      <div className="flex flex-col items-center gap-4 p-10 text-center">
        <span className="rounded-full bg-primary/10 p-5 text-primary" aria-hidden="true">
          <PowerOff size={28} />
        </span>
        <h1 className="font-headline text-2xl font-bold text-secondary">Moduł jest wyłączony</h1>
        <p className="text-on-surface-variant">
          Sekcja „{name}” nie jest obecnie używana w szkole.
          {serwis
            ? ' Możesz ją włączyć w sekcji Moduły.'
            : ' Jeśli jest potrzebna, zgłoś to przyciskiem „Zgłoś błąd lub sugestię” w górnym pasku.'}
        </p>
        <Link
          to={serwis ? '/moduly' : '/'}
          className="mt-2 rounded-lg bg-primary px-8 py-3 text-sm font-bold text-on-primary shadow-raised transition-all hover:bg-primary/90 active:scale-[0.98]"
        >
          {serwis ? 'Przejdź do modułów' : 'Wróć do panelu głównego'}
        </Link>
      </div>
    </Card>
  )
}
